<template>
    <div>
        <header class="header">
            <div class="page-brand" style="height: 100px;">
                <router-link :to="{name: 'Cms'}" class="link">
                    <span class="brand">
                      <img style="width: 35%; height: 35%" :src="application.logo.image">
                    </span>
                    <span class="brand-mini"></span>
                </router-link>
            </div>
            <div class="flexbox flex-1">
                <!-- START TOP-LEFT TOOLBAR-->
                <ul class="nav navbar-toolbar">
                    <li>
                        <a id="sidebar-toggle" class="nav-link sidebar-toggler js-sidebar-toggler"><i
                                class="ti-menu"></i></a>
                    </li>
                </ul>
                <!-- END TOP-LEFT TOOLBAR-->
                <!-- START TOP-RIGHT TOOLBAR-->
                <ul class="nav navbar-toolbar">
                    <li class="dropdown dropdown-notification">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="true"><i
                                class="fa fa-bell-o rel"><span v-if="notifications.length !== 0"
                                                               class="notify-signal"></span></i></a>
                        <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media" x-placement="bottom-end"
                            style="position: absolute; transform: translate3d(-235px, 45px, 0px); top: 0px; left: 0px; will-change: transform;">
                            <li class="dropdown-menu-header">
                                <div>
                                    <span><strong>{{notifications.length}} New</strong> Notifications</span>
                                    <a class="pull-right" @click="dismissAll">{{$t('message.clearAll')}}</a>
                                </div>
                            </li>
                            <div class="slimScrollDiv"
                                 style="position: relative; overflow: hidden; width: auto; height: 240px;">
                                <li class="list-group list-group-divider scroller" data-height="240px"
                                    data-color="#71808f" style="overflow: scroll; width: auto; height: 240px;">
                                    <div>
                                        <a v-for="(notification, index) in notifications" :key="index" href="#"
                                           class="list-group-item">
                                            <div v-if="!notification.dismissed" class="media">
                                                <div class="media-body">
                                                    <div class="font-13">{{notification.text}}</div>
                                                    <small class="text-muted">
                                                        {{$moment(notification.created).fromNow()}}
                                                    </small>
                                                </div>
                                                <div class="media-img"
                                                     @click.prevent="notificationMarkDismissed(notification)">
                                                    <span class="badge badge-success badge-big"><i
                                                            class="fa fa-check"></i></span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </li>
                                <div class="slimScrollBar"
                                     style="background: rgb(113, 128, 143) none repeat scroll 0% 0%; width: 7px; position: absolute; top: 0px; opacity: 0.4; display: none; border-radius: 7px; z-index: 99; right: 1px; height: 233.198px;"></div>
                                <div class="slimScrollRail"
                                     style="width: 7px; height: 100%; position: absolute; top: 0px; display: none; border-radius: 7px; background: rgb(51, 51, 51) none repeat scroll 0% 0%; opacity: 0.9; z-index: 90; right: 1px;"></div>
                            </div>
                        </ul>
                    </li>
                    <li class="dropdown dropdown-user">
                        <a class="nav-link dropdown-toggle link" data-toggle="dropdown">
                            <img :src="$store.getters.getProfileImage" class="img-circle"/>
                            <span v-if="$store.getters.getFullName">{{$store.getters.getFullName}}</span><i
                                class="fa fa-angle-down m-l-5"></i></a>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <router-link :to="{name: 'Profile'}" class="dropdown-item"><i class="fa fa-user"></i>Profile
                            </router-link>
                            <div class="dropdown-item">
                                <i class="fa fa-language"></i>
                                <a style="padding: 2px;" @click="changeLocale('en')"
                                   :class="{active: computedCurrentLocale === 'en', langButton: true}"
                                >EN</a>
                                <a style="padding: 2px;" @click="changeLocale('de')"
                                   :class="{active: computedCurrentLocale === 'de', langButton: true}"
                                >DE</a>
                                <a style="padding: 2px;" @click="changeLocale('it')"
                                   :class="{active: computedCurrentLocale === 'it', langButton: true}"
                                >IT</a>
                                <a style="padding: 2px;" @click="changeLocale('fr')"
                                   :class="{active: computedCurrentLocale === 'fr', langButton: true}"
                                >FR</a>
                            </div>
                            <li class="dropdown-divider"></li>
                            <a @click.prevent="logOut" class="dropdown-item" href="#"><i
                                    class="fa fa-power-off"></i>{{$t('message.logOut')}}</a>
                        </ul>
                    </li>
                </ul>
                <!-- END TOP-RIGHT TOOLBAR-->
            </div>
        </header>
        <!-- END HEADER-->
    </div>
</template>

<script>
import EventBus from '../../static/js/event-bus.js'
  // import $ from 'jquery'

  export default {
    name: 'CmsNavbar',
    data () {
      return {
        notifications: [],
         application: {
                logo: {
                       image:'/assets/logodefault.png'
                }
            }
      }
    },
    created(){
      this.getLogo()
    },
   
    methods: {
         getLogo: function(){
            this.get(this.apiPrefix, this.miscApiUrl, 'get-application-details/')
              .then(resp => {
               this.application = resp.data
                
                 if(this.application.logo === null)
                   this.application.logo = {  
                                             image: '/assets/logodefault.png'
                   }     
            })
            .catch(err => {
                console.log(err)
            })
        },
      notificationMarkDismissed (notification) {
        /** Dismiss one notification */
        this.update(this.apiPrefix, this.notificationsApiUrl, notification.id, {
          dismissed: true
        }).then((resp) => {
          this.notifications = this.notifications.filter(item => item.id !== resp.data.id)
        })
          .catch(() => {})
      },
      getNotifications () {
        if (this.$store.getters.getAuth['loggedIn']) {
          this.getList(this.apiPrefix, this.notificationsApiUrl, `?recipient_id=${this.$store.getters.getAuth['userId']}&dismissed=False`)
            .then(resp => {
              this.notifications = resp.data
            })
        }
      },
      dismissAll () {
        /** Mark all notifications as dismissed */
        this.update(this.apiPrefix, this.notificationsApiUrl + 'dismiss-all-notifications/', '', {
          notifications: this.notifications.map(row => row.id)
        })
          .then(resp => {
            this.notifications = resp.data
          }).catch(err => {
          console.log(err.response)
        })
      }
    }, 
      mounted () {

        EventBus.$on('REFRESH_CMS_NAVBAR', (params) => {
            this.application.logo.image = params
        }) 
      // get notifications immediately
      this.getNotifications()
      // set interval for polling for new notifications
      setInterval(this.getNotifications, 20 * 1000)
      this.toggleSideBar()
    },
  }
</script>

<style>
    .remove-border {
        border: 1px solid transparent;
    }
</style>
